<nav class="navbar navbar-fixed-top">
  <div class="container-fluid">
    <div class="navbar-btn">
      <button
        type="button"
        class="btn-toggle-offcanvas"
        (click)="toggleSideMenu()"
      >
        <i class="lnr lnr-menu fa fa-bars"></i>
      </button>
    </div>

    <div class="navbar-brand">
      <div *ngIf="!darkClass">
        <img
          src="assets/images/logo.png"
          alt="duesPlus Logo"
          class="img-responsive logo"
        />
      </div>
      <div *ngIf="darkClass">
        <img
          src="assets/images/logo-white.svg"
          alt="duesPlus Logo"
          class="img-responsive logo"
        />
      </div>
    </div>

    <div class="navbar-right" *ngIf="!anonymousMode">
      <div id="navbar-menu">
        <ul class="nav navbar-nav">
          <li *ngIf="organizationLogoUrl" class="org-logo-list-item">
            <img
              [src]="organizationLogoUrl"
              alt="Organization Logo"
              class="img-responsive org-logo"
            />
          </li>
          <li>{{ organization?.name }}</li>
          <li class="dropdown" ngbDropdown #myDrop="ngbDropdown">
            <a class="dropdown-toggle icon-menu" ngbDropdownToggle
              ><i class="icon-equalizer"></i
            ></a>
            <ul class="dropdown-menu user-menu menu-icon" ngbDropdownMenu>
              <li class="menu-heading">Change Organization</li>
              <li *ngFor="let org of userOrganizations">
                <a
                  (click)="changeOrganization(org); myDrop.close()"
                  *ngIf="
                    !org.subscriptionStatus ||
                      ['Active', 'Past_Due', 'Past-Due'].includes(
                        org.subscriptionStatus
                      );
                    else inActive
                  "
                >
                  <i
                    class="fa fa-group"
                    style="margin-right: 10px; margin-bottom: 10px"
                  ></i>
                  <span>{{ org?.name }}</span>
                </a>
                <ng-template #inActive>
                  <div>
                    <i
                      class="fa fa-group"
                      style="margin-right: 10px; margin-bottom: 10px"
                    ></i>
                    <span style="text-decoration: line-through"
                      >{{ org?.name }} (Inactive)</span
                    >
                  </div>
                </ng-template>
              </li>
              <li *ngIf="userOrganizations && userOrganizations.length > 1">
                <hr style="border-color: #f3f3f3" />
              </li>
              <li *ngIf="userOrganizations && userOrganizations.length > 1">
                <a
                  [routerLink]="['/organization', 'set-default-organization']"
                  (click)="myDrop.close()"
                >
                  <i
                    class="icon-settings"
                    style="margin-right: 10px; margin-bottom: 10px"
                  ></i>
                  <span>Set Default Organization</span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <a
              [routerLink]="['/authentication/logout']"
              class="icon-menu d-none d-sm-block"
              ><i class="icon-login"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
